'use client';
import React from 'react';
import { XCircle } from 'lucide-react';
import { usePlanningSearch } from '../state/PlanningSearchContext';

interface AppliedFiltersBarProps {
  variant?: 'default' | 'compact';
  className?: string;
}

const AppliedFiltersBar: React.FC<AppliedFiltersBarProps> = ({ variant = 'default', className }) => {
  const { activeChips, clearAll } = usePlanningSearch();

  if (activeChips.length === 0) {
    return null;
  }

  const baseClasses = variant === 'compact'
    ? 'flex flex-wrap items-center gap-1.5 border-l-2 border-[var(--c-text-primary)] bg-[var(--c-surface)] px-3 py-2 text-xs'
    : 'mt-4 flex flex-wrap items-center gap-2 border-l-2 border-[var(--c-text-primary)] bg-[var(--c-surface)] px-4 py-3';

  return (
    <div className={`${baseClasses} ${className ?? ''}`}>
      <span className="pr-kicker">Active filters</span>
      {activeChips.map(chip => (
        <button
          key={chip.id}
          type="button"
          onClick={chip.onRemove}
          className="pr-chip pr-chip--on group"
        >
          <span>{chip.label}</span>
          <XCircle className="h-3.5 w-3.5 opacity-70 group-hover:opacity-100" aria-hidden />
        </button>
      ))}
      <button
        type="button"
        onClick={clearAll}
        className="pr-textlink ml-auto text-xs"
      >
        Clear all
      </button>
    </div>
  );
};

export default AppliedFiltersBar;